/** "Sat - 15:00" — the kickoff slot's text, shared by the self-view card and another
 * player's reveal so the two grids read and measure identically. */
export function formatKickoffLabel(kickoff: string): string {
  const date = new Date(kickoff)
  const weekday = date.toLocaleString('en-GB', { weekday: 'short' })
  const time = date.toLocaleString('en-GB', { hour: '2-digit', minute: '2-digit' })
  return `${weekday} - ${time}`
}
